export default __webpack_public_path__ + "static/media/insta4.14171c98.png";